import React from 'react'
import Career_2 from '../../../assets/images/home_page_4/careers/02.png'

const Career = () => {
    return (
        <>
            <section id="careers" className="careers-main-block">
                <div className="container">
                    <div className="careers-block">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="careers-dtl-block">
                                    <h1 className="career-heading">
                                        Transform Your Career <span> Transform Your Life!</span>
                                    </h1>
                                    <form>
                                        <div className="form-group career-input">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Email Address"
                                                aria-label="Email Address"
                                                aria-describedby="button-addon2"
                                            />
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                id="button-addon2"
                                            >
                                                <i className="flaticon-mail" /> Subscribe
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-5 text-center">
                                <div className="careers-img">
                                    <img
                                        src={Career_2}
                                        className="img-fluid main-img"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Career
